import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet';
import { LanguageProvider } from '../../../core/language-provider';
import { settings } from '../../../config/settings';
import './style.css';

export default function HeaderTitle() {
    const location = useLocation();

    const getPageTitle = () => {
        const path = location.pathname;
        const completePath  = location.pathname + location.search;

        // Home/Dashboard
        if (path === '/' || path === '/dashboard') {
            return 'Dashboard';
        }

        // Entity pages
        const entityMatch = path.match(/^\/entity\/([^/]+)/);
        if (entityMatch) {
            const entity = entityMatch[1];
            const entityName = LanguageProvider.get('entity.' + entity);

            // Add page
            if (completePath.includes('/add')) {
                return `${LanguageProvider.get('defaults.add')} - ${entityName}`;
            }

            // Edit page
            if (completePath.includes('/edit?id=')) {
                return `${LanguageProvider.get('defaults.edit')} - ${entityName}`;
            }

            // Clone page
            if (completePath.includes('/clone?id=')) {
                return `${LanguageProvider.get('defaults.clone')} - ${entityName}`;
            }

            // View/Detail page
            if (completePath.includes('/item?id=')) {
                return `${LanguageProvider.get('defaults.details')} - ${entityName}`;
            }

            // List page
            return entityName;
        }

        // Settings page
        if (path === '/settings') {
            return LanguageProvider.get('header.settings');
        }

        // Analytics page
        if (path === '/analytics') {
            return 'Analytics';
        }

        // About/License page
        if (path === '/about' || path === '/license') {
            return LanguageProvider.get('header.about');
        }

        // Custom pages
        const pageMatch = path.match(/^\/page\/([^/]+)/);
        if (pageMatch) {
            return pageMatch[1];
        }

        return '';
    };

    const renderBreadcrumbs = () => {
        const path = location.pathname;
        const completePath  = location.pathname + location.search;

        // Home/Dashboard
        if (path === '/' || path === '/dashboard') {
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item active>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // Breadcrumbs per le entità standard
        const entityMatch = path.match(/^\/entity\/([^/]+)/);
        if (entityMatch) {
            const entity = entityMatch[1];
            const entityName = LanguageProvider.get('entity.' + entity);

            // Breadcrumbs per pagine di add, edit, clone
            if ((completePath.includes('/add') || completePath.includes('/edit?id=') || completePath.includes('/clone?id=') || completePath.includes('/item?id=')) && path.includes('entity')) {
                return (
                    <Breadcrumb className="header-breadcrumb">
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                            <FontAwesomeIcon icon="home" />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/entity/${entity}` }}>
                            {entityName}
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {path.includes('/add') && LanguageProvider.get('defaults.add')}
                            {completePath.includes('/edit?id=') && LanguageProvider.get('defaults.edit')}
                            {completePath.includes('/clone?id=') && LanguageProvider.get('defaults.clone')}
                            {completePath.includes('/item?id=') && LanguageProvider.get('defaults.view')}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                );
            }

            // Breadcrumbs per la pagina principale del datagrid
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {entityName}
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // Logout page
        if (path === '/logout') {
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {LanguageProvider.get('header.logout')}
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // Settings page
        if (path === '/settings') {
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {LanguageProvider.get('header.settings')}
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // Analytics page
        if (path === '/analytics') {
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        Analytics
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // About/License page
        if (path === '/about' || path === '/license') {
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {LanguageProvider.get('header.about')}
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // Crystalckd page
        if (path === '/crystalckd') {
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        crystalckd
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // Custom pages
        const pageMatch = path.match(/^\/page\/([^/]+)/);
        if (pageMatch) {
            return (
                <Breadcrumb className="header-breadcrumb">
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                        <FontAwesomeIcon icon="home" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {pageMatch[1]}
                    </Breadcrumb.Item>
                </Breadcrumb>
            );
        }

        // Default: nessuna breadcrumb
        return null;
    };

    const pageTitle = getPageTitle();
    const breadcrumbs = renderBreadcrumbs();

    return (
        <>
            <Helmet>
                <title>{pageTitle ? `${pageTitle} - ${settings.title}` : settings.title}</title>
            </Helmet>
            {breadcrumbs}
        </>
    );
}
